module.exports = __webpack_public_path__ + "img/Puke.566d4df6.jpeg";